import { c as _c } from "react/compiler-runtime";
import { IcoUsers24 } from '@onefootprint/icons';
import type { HostedBusinessOwner } from '@onefootprint/request-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BosListEditForm, type EditFormValues } from './bos-list-edit-form';
import { BosListItem } from './bos-list-item';
export type BosListProps = {
  immutableBos: HostedBusinessOwner[];
  onSubmit: (payload: {
    uuid: string;
    ownershipStake: number;
  }) => void;
};

/** Renders a list of immutable beneficial owners and allows editing only their ownership stake. */
export const BosList = t0 => {
  const $ = _c(20);
  const {
    immutableBos,
    onSubmit
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectBusinessData.beneficialOwners.list"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const [editingBo, setEditingBo] = useState(null);
  let t2;
  if ($[1] !== onSubmit) {
    t2 = bo => async formValues => {
      await onSubmit({
        uuid: bo.uuid,
        ownershipStake: formValues.ownershipStake
      });
      setEditingBo(null);
    };
    $[1] = onSubmit;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleSubmit = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IcoUsers24 color="primary" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t(_temp);
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="flex items-center gap-2 py-3 px-4 grow">{t3}<h3 className="text-label-2 text-primary">{t4}</h3></div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== editingBo?.uuid || $[9] !== handleSubmit || $[10] !== immutableBos) {
    let t7;
    if ($[12] !== editingBo?.uuid || $[13] !== handleSubmit) {
      t7 = bo_0 => {
        const name = `${bo_0.decryptedData["id.first_name"]} ${bo_0.decryptedData["id.last_name"]}`.trim();
        const isCurrentBo = bo_0.isAuthedUser;
        const isEditing = editingBo?.uuid === bo_0.uuid;
        return <li key={bo_0.uuid} className=":not(:last-child):border-b :not(:last-child):border-tertiary :not(:last-child):pb-4 :not(:last-child):mb-4">{isEditing ? <BosListEditForm bo={bo_0} onSubmit={handleSubmit(bo_0)} onCancel={() => {
            setEditingBo(null);
          }} /> : <BosListItem name={name} isCurrentBo={isCurrentBo} ownershipStake={bo_0.ownershipStake || 0} onEdit={() => setEditingBo(bo_0)} />}</li>;
      };
      $[12] = editingBo?.uuid;
      $[13] = handleSubmit;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    t6 = immutableBos.map(t7);
    $[8] = editingBo?.uuid;
    $[9] = handleSubmit;
    $[10] = immutableBos;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <ul className="pt-1 px-4 pb-4">{t6}</ul>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t7) {
    t8 = <div className="border border-tertiary rounded-sm">{t5}{t7}</div>;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
function _temp($) {
  return $.title;
}